import React from "react";
import { View, Text, ActivityIndicator } from "react-native";
import { useSelector } from "react-redux";
import Modal from "modal-enhanced-react-native-web";
import { colors } from "../../../const";

function LoadingDialog(props) {
    const isVisible = useSelector(({ setting }) => setting.isLoadingDialogVisible)

    return (
        <Modal
            isVisible={isVisible}
            style={{ justifyContent: "center", alignItems: "center" }}
            animationIn="fadeIn"
            animationOut="fadeOut"
            backdropOpacity={0.4}
        >
            <View style={{ backgroundColor: colors.white, borderRadius: 10, justifyContent: "center", alignItems: "center", height: 80, width: 80 }}>
                <ActivityIndicator
                    color={colors.indigo}
                    size={28}
                    size="large"
                />
            </View>
        </Modal>
    )
}

export default LoadingDialog;